import React, { FC, useEffect, useState } from 'react'
import { Col, Container, Form, Modal, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { FileRegistrationModel } from '../../models/applicationRegistration/fileRegistration/fileRegistrationModel'
import dashboardService from '../../services/dashboardService'
import { getSelectedTimeFilters } from '../../store/dashboard/selectors'
import { fileRedirectUtil } from '../../utils/utilFunctions'
import LoadingComponent from '../common/loading/LoadingComponent'
import filterIcon from '../../assets/images/filter-icon.svg'
import arrowDown from '../../assets/images/arrow-down.svg'

export interface AllocateModalProps {
  status: string
  onCancel?: React.MouseEventHandler<HTMLButtonElement>
}

const DashboardItemsModal: FC<AllocateModalProps> = ({ status, onCancel }) => {
  const timeFilters = useSelector(getSelectedTimeFilters)
  const [applicationList, setApplicationList] = useState([])
  const [loading, setLoading] = useState(true)
  const [filterOpen, setFilterOpen] = useState(false)
  const [referenceNumber, setReferenceNumber] = useState('')
  const [applicantName, setApplicantName] = useState('')
  const history = useHistory()

  const getApplications = async (refNumber?: string, applicant?: string) => {
    setLoading(true)
    const response = await dashboardService.apiDashboardDataView({
      status,
      to: timeFilters.filter.to ?? null,
      from: timeFilters.filter.value ?? null,
      timeFilterIndex: timeFilters.index,
      referenceNumber:
        refNumber === undefined ? null : refNumber.trim() || null,
      applicantName: applicant === undefined ? null : applicant.trim() || null,
    })
    if (response.status === 200) {
      setApplicationList(response.data)
    }
    setLoading(false)
  }

  useEffect(() => {
    getApplications()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only refetch when status or time filter changes
  }, [
    status,
    timeFilters.index,
    timeFilters.filter.value,
    timeFilters.filter.to,
  ])

  const handleFilter = () => {
    getApplications(referenceNumber, applicantName)
  }

  const handleClick = (file: FileRegistrationModel) => {
    console.log(file)
    const basePath = fileRedirectUtil(
      file.status,
      file.programType,
      file.scheme,
      file.id
    )
    // switch (status.toUpperCase()) {
    //   case 'FILE DRAFTED':
    //     basePath = `application-registration/file-registration/file-registration/draft/${file.id}`
    //     break
    //   case 'APPLICATION DRAFTED':
    //     basePath = `application-registration/${file.programType.toLowerCase()}/${file.scheme.toLowerCase()}/view/${
    //       file.id
    //     }`
    //     break
    //   case 'APPLICATION CREATION PENDING':
    //     basePath = `application-registration/${file.programType.toLowerCase()}/${file.scheme.toLowerCase()}/view/${
    //       file.id
    //     }`
    //     break
    //   case 'APPLICATION RETURNED':
    //     basePath = `application-registration/${file.programType.toLowerCase()}/${file.scheme.toLowerCase()}/return/${
    //       file.id
    //     }`
    //     break
    //   default:
    //     basePath = ''
    //     break
    // }

    if (basePath != '') {
      history.push(basePath)
    }
  }

  const renderFilesList = () => {
    return applicationList.map((file: FileRegistrationModel, index: number) => {
      console.log(file)
      return (
        <Row
          className="file-item mb-3"
          key={`file-${index}`}
          role={'button'}
          onClick={() => {
            handleClick(file)
          }}
        >
          {file.status.toUpperCase() === 'FILE DRAFTED' ? (
            <>
              <div>
                <span className="header-span">Applicant : </span>
                <span>{file.applicantName}</span>
              </div>
              <div>
                <span className="header-span">Scheme : </span>
                <span>{file.scheme}</span>
              </div>
              <div>
                <span className="header-span">Created Date : </span>
                <span>
                  {new Date(file.createdDateTime * 1000).toLocaleString()}
                </span>
              </div>
            </>
          ) : (
            <>
              <div>
                <span className="header-span">{file.referenceNumber}</span>
              </div>
              <div>
                <span className="header-span">Applicant : </span>
                <span>{file.applicantName}</span>
              </div>
            </>
          )}
        </Row>
      )
    })
  }

  return (
    <Modal
      size="lg"
      show={true}
      onHide={onCancel}
      aria-labelledby="example-modal-sizes-title-sm"
      dialogClassName="dashboard-modal-layout"
      contentClassName="custom-modal-content"
    >
      <Modal.Header
        closeButton
        closeVariant="white"
        className="custom-modal-header"
      >
        <Modal.Title id="example-modal-sizes-title-sm">
          Application Files
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Filter Section - collapsible */}
        <div
          className={`dashboard-modal-filter${
            filterOpen ? ' dashboard-modal-filter-expanded' : ''
          }`}
        >
          <button
            type="button"
            className="dashboard-modal-filter-header"
            onClick={() => setFilterOpen(!filterOpen)}
            aria-expanded={filterOpen}
          >
            <span className="dashboard-modal-filter-header-label">
              Filter
              <img
                src={arrowDown}
                alt=""
                className={
                  filterOpen ? 'dashboard-modal-filter-arrow-open' : ''
                }
              />
            </span>
          </button>
          {filterOpen && (
            <div className="p-4 time-filter-body">
              <Form>
                <Row className="mb-3">
                  {status.toUpperCase() !== 'FILE DRAFTED' && (
                    <Col sm="6">
                      <Form.Group controlId="filterReference">
                        <Form.Label>Reference Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter reference number"
                          value={referenceNumber}
                          onChange={(e) => setReferenceNumber(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  )}
                  <Col sm={status.toUpperCase() === 'FILE DRAFTED' ? 12 : 6}>
                    <Form.Group controlId="filterApplicant">
                      <Form.Label>Applicant Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter applicant name"
                        value={applicantName}
                        onChange={(e) => setApplicantName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="dashboard-modal-filter-btn-wrap">
                  <button
                    type="button"
                    className="save-button dashboard-modal-filter-btn"
                    onClick={handleFilter}
                  >
                    <img src={filterIcon} alt="" />
                    Filter
                  </button>
                </div>
              </Form>
            </div>
          )}
        </div>
        <Container className="application-file-modal">
          {loading ? (
            <div className="row justify-content-center">
              <LoadingComponent />
            </div>
          ) : (
            <>{renderFilesList()}</>
          )}
        </Container>
      </Modal.Body>
    </Modal>
  )
}

export default DashboardItemsModal
